<template>
  <div class="d-flex cate-box-menu cate-card-height">
    <div class="card d-flex border-0" style="width: 100%;">
      <div class="cate-list d-flex flex-column">
        <!-- 一级分类 -->
        <div v-if="categoryList.length === 0" style="min-height: 400px"></div>
        <div v-else class="d-flex flex-fill" v-for="(item,index) in categoryList" :ref="'wrap'+index" :key="index" @mouseenter="mouse(index)" @mouseleave="mouseOut(index)">
          <a :href="'/categoryItem/'+item.key" class="align-self-center font-weight-normal" :ref="'wrap-a'+index">{{item.title}}</a>
          <!-- 子分类 -->
          <div class="itemBox-wrap" v-show="item.chilidShow">
            <b-card class="item-chlid-box cate-card-height" style="color: black" :header="item.title">
              <div class="itemList">
                <div class="itemBox-wrap-text" v-for="(child,index) in item.children" :key="index">
                  <b-link :to="(child.leaf?'/productItem/':'/categoryItem/')+child.key" class="align-self-center font-weight-normal" >{{child.title}}</b-link>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="d-flex flex-fill">
          <b-link to="/category" class="align-self-center" href="#" style="color: #007bff;">View All</b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";

export default {
  name: "categoryListMenuList",
  props:{
    
  },
  data(){
    return{
      categoryList:[]
    }
  },
  async created() {
    await this.init();
  },
  methods:{
    async init() {
      await this.getMenuList();
    },
    async getMenuList() {
      this.$store.getters.catemenuList.then(res => {
        this.categoryList = res
      })
      /*await getAction("/front/home/cateMenuList", {}).then(res => {
        res.result.cateMenuList.forEach(item => {
          item.chilidShow = false;
          this.categoryList.push(item)
        })
      })*/
    },
    mouse(index){
      this.categoryList.forEach(item => {item.chilidShow = false})
      this.categoryList[index].chilidShow = true;
      const element = this.$refs["wrap-a"+index][0];
      element.classList.toggle('a-houver-cls')
    },
    mouseOut(index){
      this.categoryList[index].chilidShow = false;
      const element = this.$refs["wrap-a"+index][0];
      element.classList.remove('a-houver-cls')
    }
  },
}
</script>

<style lang="scss">
.item-chlid-box{
  padding-right: 0 !important;
  padding-left: 0 !important;

  .card-header{
    background-color: rgb(0,0,0,0) !important;
  }
  .card-body{
    padding-left: 0px;
  }
}
.a-houver-cls{
  color: var(--swiper-theme-color) !important;
  text-decoration: underline;
}
.cate-list div{
  padding-left: 20px;
  padding-right: 20px;
}
.itemList{
  padding-left: 8px !important;
  width: 600px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 40px;
  max-height: 396px;
  overflow-y: auto;
}
.itemBox-wrap-text{
  padding-bottom: 15px;
}
.itemBox-wrap{
  padding-left: 15px;
  position: absolute;
  left: 260px;
  top: 0;
  z-index: 2;
}
.cate-box-menu>div{
  border-radius: 6px;
  box-shadow:0 3px 25px 0 rgba(206,214,227,.4);
}
.cate-box-menu{
    width: 260px;
}
.cate-box-menu .cate-list{
  text-align: left;
  height: 100%;
}
.cate-card-height{
  height: 495px;
}

.cate-box-menu .cate-list a,.itemBox-wrap-text{
  color: var(--main-text-color);
  font-size: 13px !important;
  vertical-align: center;
  white-space: nowrap;   /* 防止文本换行 */
  overflow: hidden;      /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.cate-box-menu .cate-list a:hover{
  color: var(--swiper-theme-color) !important;
}
</style>
